import {apolloClient} from "../apolloClient";
import {QUERY_BLOCKED_DATES, QUERY_IS_ME, QUERY_LESSONS} from "../gql";
import {filterNotInThePast} from "../utils/lessonEventMapper";

export default (userId) => {
    let user_id;
    return {
        id: "userLessonsEventSource",
        events: async ({end}, successCallback, failureCallback) => {

            const startDateString = window.moment().format('YYYY-MM-DD'),
                endDateString = window.moment(end).format('YYYY-MM-DD');
            try {
                if (userId) {
                    user_id = userId;
                } else {
                    const {data: {me}} = await apolloClient.query({
                        query: QUERY_IS_ME
                    });
                    user_id = me.id;
                }
                const {data: {blocked_dates}} = await apolloClient.query({
                    fetchPolicy: "no-cache",
                    query: QUERY_BLOCKED_DATES
                });

                const {data: {lessons}} = await apolloClient.query({
                    fetchPolicy: "no-cache",
                    query: QUERY_LESSONS, variables: {
                        where: {
                            _and: [
                                {
                                    date: {_gte: startDateString},
                                }, {
                                    date: {_lte: endDateString},
                                },
                                {
                                    users_lessons: {
                                        user: {
                                            id: {_eq: user_id}
                                        }
                                    }
                                },
                                {
                                    _not: {
                                        date: {_in: blocked_dates.map(({date}) => date)}
                                    }
                                }
                            ]
                        }
                    }
                });
                successCallback(lessons.map((lesson) => {
                    const {date: dateString, id, lessons_class_schedules} = lesson;
                    const {class_schedule} = lessons_class_schedules[0];
                    const {from_time, to_time} = class_schedule;
                    return {
                        title: "Uw Fysisportles",
                        start: `${dateString}T${from_time}`,
                        end: `${dateString}T${to_time}`,
                        extendedProps: {
                            userLessonEvent: true,
                            lesson
                        }
                    }
                }).filter(filterNotInThePast));
            } catch (e) {
                failureCallback(e);
            }
        },
        className: "user-lesson-event",
        color: "darkgreen"
    }
};